<script>
import Layout from '@layouts/default'

export default {
  page: {
    title: 'Secure Shopping | AutoCheck.com',
    meta: [
      { name: 'description', content: 'Secure Shopping' },
      { name: 'keywords', content: 'Secure Shopping' },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/secure-shopping',
      },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="row mt-4 mb-4">
      <div class="col-md-9 col-12">
        <h1>Secure Online Shopping with AutoCheck</h1>
        <hr />
        <h3 class="titleBlue">Is it Safe to Use My Credit Card?</h3>
        <p>
          <strong>We keep your credit card transaction safe by using</strong>
          industry standard secure socket layer (SSL) software, which is among
          the best technology available for ensuring secure online commerce
          transactions. SSL encrypts your credit card information so that it
          cannot be read as it is transmitted over the Internet, whether through
          a desktop computer or a mobile device. You may also choose to checkout
          using your PayPal account, which provides similar security and
          protection.
        </p>
        <p id="safe">
          <strong>Is my account information safe?</strong>
        </p>
        <p>
          AutoCheck.com servers are protected by secure firewalls designed to
          keep your information safe. We ask that you create a password
          protected account at AutoCheck.com so that you can access your vehicle
          history reports at any time via your desktop computer or mobile
          device, but we DO NOT store your credit card information online, so it
          is not vulnerable to malicious attacks.
        </p>
        <h3 class="titleBlue">Our Safe Shopping Guarantee</h3>
        <ol>
          <li>
            Under the Fair Credit Billing Act, your bank cannot hold you liable
            for more than $50.00 of fraudulent charges. If your bank does hold
            you liable for any of this $50.00, AutoCheck.com will cover the
            entire liability for you, up to the full $50.00. AutoCheck.com will
            only cover this liability if the unauthorized use of your credit
            card resulted through no fault of your own from purchases made at
            AutoCheck.com while using the secure server.
          </li>
          <li>
            In the event of unauthorized use of your credit card, you must
            notify your credit card provider in accordance with its reporting
            rules and procedures.
          </li>
        </ol>
        <h3 id="privacy" class="titleBlue">Our Privacy Policy</h3>
        <p>
          AutoCheck.com respects your privacy and is committed to protecting it.
          For more details, please see our
          <BaseLink href="https://www.experian.com/privacy/auto_check"
            >Privacy Policy »</BaseLink
          >
        </p>
      </div>
      <div class="col-md-3 col-12">
        <div class="content-page-right-navigation">
          <p style="text-align: left;">
            <b style="font-size: 14px;">Secure Online Shopping</b>
          </p>
          <hr />
          <ul>
            <li>
              <router-link to="secure-shopping" class="secondary-anchor-link"
                >Secure Online Shopping</router-link
              >
            </li>
            <li>
              <a v-scroll-to="'#safe'" class="secondary-anchor-link" href="#"
                >Safe Shopping Guarantee</a
              >
            </li>
            <li>
              <a v-scroll-to="'#privacy'" class="secondary-anchor-link" href="#"
                >Privacy Policy</a
              >
            </li>
            <li>
              <BaseLink
                :to="{ name: 'backed-by-experian' }"
                class="secondary-anchor-link"
                >Experian Insights</BaseLink
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
